import { RECEIPT_PRINTER_NOT_CONFIGURED } from './thermalReceiptTypes';

export function resolveReceiptPrintErrorMessage(
  code: string,
  error: string,
  t: (key: string, options?: Record<string, unknown>) => string,
): string {
  if (code === RECEIPT_PRINTER_NOT_CONFIGURED) {
    return t('pos.print.not_configured');
  }
  return t('pos.print.failed', { error: error || code });
}
